import { FC } from 'react';
import { compose } from 'redux';
import { injectTranslations } from 'ia-react-core';
import MobileSmartBanner, { MobileSmartBannerProps } from './MobileSmartBanner';
import fr from './translations/fr';
import en from './translations/en';

export default compose<FC<MobileSmartBannerProps>>(
  injectTranslations('MobileSmartBanner', [
    { language: 'fr', resource: fr },
    { language: 'en', resource: en },
  ]),
)(MobileSmartBanner);
